import { Button } from '@/components/ui-kit/button';
import { SOCIAL_AUTH_PROVIDERS } from '@/constant/sso';
import { startSocialLogin } from '@/api-client/use-social-login';

export const GoogleLoginButton = ({ text = "Log in", iconOnly = false }: { text?: string; iconOnly?: boolean }) => {
  const providerConfig = SOCIAL_AUTH_PROVIDERS.google;

  const handleLogin = async () => {
    try {
      const clientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;
      if (!clientId) {
        console.error('[Google SSO] Missing VITE_GOOGLE_CLIENT_ID');
        return;
      }
      await startSocialLogin(clientId, providerConfig.value);
    } catch (error) {
      console.error('[Google SSO] Initiate Failed:', error);
    }
  };

  return (
    <Button variant="outline" className={iconOnly ? "w-14 h-14 px-0" : "w-full h-12"} onClick={handleLogin} type="button">
      <img
        src={providerConfig.imageSrc}
        width={24}
        height={24}
        alt={`${providerConfig.label} logo`}
        className={iconOnly ? "font-bold" : "mr-2 font-bold"}
      />
      {!iconOnly && `${text} with ${providerConfig.label}`}
    </Button>
  );
};
